export const palette = {
  primary: {
    dark: "#009AA8",
    main: "#00607B",
    light: "#97D5DC",
    contrastText: "#ffffff",
  },
  secondary: {
    dark: "#b2451c",
    main: "#009AA8",
    light: "#ff8253",
    contrastText: "#ffffff",
  },
  background: {
    default: "#ffffff",
    paper: "#ffffff",
  },
  action: {
    disabled: "rgb(190, 190, 190)",
    disabledBackground: "rgba(70, 70, 70, 0.20)",
    selected: "#000000",
    active: "#333333",
  },
  divider: "#a0a6a7",
  severity: {
    error: "#FF5141",
    info: "#2255FAi",
    success: "#27AE60",
    warning: "#F2994A",
  },
  // Custom palette keys that per-tenant themes define and shared components
  // read (e.g. `theme.palette.button.text` in venue/common styled components).
  // The fallback theme (used on the shared deployment, where only `primary` is
  // patched at runtime) MUST carry these or those components crash with
  // "Cannot read properties of undefined". Neutral/grayscale by design — the
  // tenant primary is the only accent and is applied separately at runtime.
  accordion: {
    expanded: "#F3F3F3",
    collapse: "#F9F9F9",
  },
  info: {
    main: "#515557",
  },
  input: {
    focus: "#1E1E1E",
    border: "#DEDFDF",
    error: "#FF0000",
  },
  text: {
    secondary: "#0a0a0a",
    disabled: "rgb(190,190,190)",
    main: "#000000",
  },
  border: {
    default: "#DEDFDF",
  },
  button: {
    text: "#000000",
  },
};
